import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import {X, Printer} from 'lucide-react'
import { Guia } from "../context/GuiasContext"
import { useGuias } from "../context/GuiasContext"
import QRCode from "qrcode"

interface VisualizarGuiaProps {
  guia: Guia
  onClose: () => void
}

export default function VisualizarGuia({ guia, onClose }: VisualizarGuiaProps) {
  const { logoUrl, dadosPrefeitura } = useGuias()
  const [qrCodeUrl, setQrCodeUrl] = useState("")

  useEffect(() => {
    const generateQRCode = async () => {
      try {
        const guiaUrl = `${window.location.origin}${window.location.pathname}?guia=${guia._id}`
        const qrDataUrl = await QRCode.toDataURL(guiaUrl, {
          width: 120,
          margin: 1,
          color: {
            dark: "#004161",
            light: "#FFFFFF"
          }
        })
        setQrCodeUrl(qrDataUrl)
      } catch (error) {
        console.error("Erro ao gerar QR Code:", error)
      }
    }
    generateQRCode()
  }, [guia._id])

  const generatePrintHTML = () => {
    const printWindow = window.open("", "_blank", "width=900,height=700")
    if (!printWindow) {
      alert("Por favor, permita popups neste site para imprimir a guia.")
      return
    }

    const fmtDate = (d?: string) => {
      if (!d) return "Não informada"
      try { return new Date(d).toLocaleDateString("pt-BR") } catch { return d }
    }

    // Página 1 — documento da guia (HTML puro, usando table em vez de grid para compatibilidade de impressão)
    const paginaGuia = `
      <div style="padding:20px 25px;font-family:Arial,sans-serif;font-size:12px;color:#111;">
        <div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:10px;padding-bottom:10px;border-bottom:2px solid #004161;">
          <img src="${logoUrl}" alt="Logo" style="height:60px;width:auto;object-fit:contain;" />
          <div style="flex:1;">
            <div style="font-size:15px;font-weight:bold;color:#004161;">${dadosPrefeitura.nomePrefeitura}</div>
            <div style="font-size:11px;color:#333;">${dadosPrefeitura.secretaria}</div>
            <div style="font-size:11px;color:#333;">${dadosPrefeitura.departamento}</div>
            <div style="font-size:10px;color:#555;margin-top:2px;">${dadosPrefeitura.endereco} | CEP: ${dadosPrefeitura.cep}</div>
            <div style="font-size:10px;color:#555;">CNPJ: ${dadosPrefeitura.cnpj} | Tel: ${dadosPrefeitura.telefone}</div>
          </div>
        </div>
        <h3 style="text-align:center;font-size:14px;font-weight:bold;text-transform:uppercase;color:#004161;margin:8px 0 12px;">GUIA DE SEPULTAMENTO Nº ${guia.numero}</h3>
        <div style="margin-bottom:10px;">
          <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Falecido</div>
          <table style="width:100%;border-collapse:collapse;">
            <tr>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Nome Completo:</div><div style="font-size:11px;font-weight:500;">${guia.nomeFalecido || ""}</div></td>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Data de Nascimento:</div><div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataNascimento)}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Idade:</div><div style="font-size:11px;font-weight:500;">${guia.idade || ""} anos</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Nome da Mãe:</div><div style="font-size:11px;font-weight:500;">${guia.nomeMae || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Nome do Pai:</div><div style="font-size:11px;font-weight:500;">${guia.nomePai || ""}</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Naturalidade:</div><div style="font-size:11px;font-weight:500;">${guia.naturalidade || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Cor:</div><div style="font-size:11px;font-weight:500;">${guia.cor || ""}</div></td>
              <td></td>
            </tr>
          </table>
        </div>
        <div style="margin-bottom:10px;">
          <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Óbito</div>
          <table style="width:100%;border-collapse:collapse;">
            <tr>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Causa da Morte:</div><div style="font-size:11px;font-weight:500;">${guia.causaMorte || ""}</div></td>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Local do Óbito:</div><div style="font-size:11px;font-weight:500;">${guia.localObito || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Data do Óbito:</div><div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataObito)}</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Hora do Óbito:</div><div style="font-size:11px;font-weight:500;">${guia.horaObito || ""}</div></td>
            </tr>
          </table>
        </div>
        <div style="margin-bottom:10px;">
          <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Sepultamento</div>
          <table style="width:100%;border-collapse:collapse;">
            <tr>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Óbito Nº:</div><div style="font-size:11px;font-weight:500;">${guia.obitoNumero || ""}</div></td>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Fls:</div><div style="font-size:11px;font-weight:500;">${guia.fls || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Livro Nº:</div><div style="font-size:11px;font-weight:500;">${guia.livroNumero || ""}</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Cartório:</div><div style="font-size:11px;font-weight:500;">${guia.cartorio || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Data do Sepultamento:</div><div style="font-size:11px;font-weight:500;">${fmtDate(guia.dataSepultamento)}</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Cemitério:</div><div style="font-size:11px;font-weight:500;">${guia.cemiterio || ""}</div></td>
            </tr>
            <tr>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Valor Pago:</div><div style="font-size:11px;font-weight:500;">R$ ${guia.valorPago || ""}</div></td>
              <td style="padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Conforme Talão Nº:</div><div style="font-size:11px;font-weight:500;">${guia.talaoNumero || ""}</div></td>
            </tr>
          </table>
        </div>
        <div style="margin-bottom:12px;">
          <div style="font-size:12px;font-weight:bold;color:#004161;border-bottom:1px solid #ccc;margin-bottom:5px;padding-bottom:2px;">Informações do Solicitante</div>
          <table style="width:100%;border-collapse:collapse;">
            <tr>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">Nome do Solicitante:</div><div style="font-size:11px;font-weight:500;">${guia.nomeSolicitante || ""}</div></td>
              <td style="width:50%;padding:2px 4px;vertical-align:top;"><div style="font-size:10px;color:#666;">CPF:</div><div style="font-size:11px;font-weight:500;">${guia.cpfSolicitante || ""}</div></td>
            </tr>
          </table>
        </div>
        <table style="width:100%;border-collapse:collapse;margin-top:20px;">
          <tr>
            <td style="width:50%;text-align:center;padding:0 20px;"><div style="border-top:1px solid #999;padding-top:5px;"><div style="font-size:11px;font-weight:500;">Assinatura do Responsável</div><div style="font-size:9px;color:#666;">Secretaria Municipal</div></div></td>
            <td style="width:50%;text-align:center;padding:0 20px;"><div style="border-top:1px solid #999;padding-top:5px;"><div style="font-size:11px;font-weight:500;">Assinatura do Solicitante</div><div style="font-size:9px;color:#666;">${guia.nomeSolicitante || ""}</div></div></td>
          </tr>
        </table>
        <div style="margin-top:16px;text-align:center;font-size:9px;color:#888;">
          <div>Documento emitido em ${new Date().toLocaleDateString("pt-BR")} às ${new Date().toLocaleTimeString("pt-BR")}</div>
          ${qrCodeUrl ? `<div style="margin-top:8px;"><div style="font-size:9px;color:#888;margin-bottom:4px;">Escaneie para baixar o PDF</div><img src="${qrCodeUrl}" alt="QR Code" style="width:80px;height:80px;" /></div>` : ""}
        </div>
      </div>
    `

    // Página 2 — anexo (certidão), separada por quebra de página explícita
    let paginaAnexo = ""
    if (guia.certidaoBase64) {
      if (guia.certidaoBase64.startsWith("data:application/pdf")) {
        // PDF: usar iframe em vez de embed — browsers modernos bloqueiam embed com data: URI na impressão
        paginaAnexo = `
          <div style="page-break-before:always;break-before:page;display:block;width:100%;height:297mm;margin:0;padding:0;overflow:hidden;">
            <div style="font-size:13px;font-weight:bold;color:#004161;text-align:center;padding:8px 0 6px;">Certidão de Óbito Anexada</div>
            <iframe src="${guia.certidaoBase64}" style="width:100%;height:calc(297mm - 34px);border:none;display:block;" frameborder="0"></iframe>
          </div>`
      } else {
        // Imagem: contida na página, sem corte
        paginaAnexo = `
          <div style="page-break-before:always;break-before:page;display:block;width:100%;min-height:200mm;margin:0;padding:20px;text-align:center;box-sizing:border-box;">
            <div style="font-size:13px;font-weight:bold;color:#004161;margin-bottom:12px;">Certidão de Óbito Anexada</div>
            <img src="${guia.certidaoBase64}" alt="Certidão de Óbito"
              style="max-width:100%;max-height:240mm;height:auto;width:auto;border:1px solid #ccc;object-fit:contain;display:block;margin:0 auto;" />
          </div>`
      }
    }

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="pt-BR">
        <head>
          <meta charset="UTF-8">
          <title>Guia de Sepultamento - ${guia.numero}</title>
          <style>
            * { box-sizing:border-box; margin:0; padding:0; }
            html, body { background:white; font-family:Arial,sans-serif; }
            @page { size:A4 portrait; margin:10mm; }
            @page :first { margin:10mm; }
            @media print {
              body { margin:0; }
              * { -webkit-print-color-adjust:exact !important; print-color-adjust:exact !important; }
              .pagina-guia { page-break-after: always; break-after: page; }
              .pagina-anexo { page-break-before: always; break-before: page; }
              iframe { -webkit-print-color-adjust:exact !important; }
            }
          </style>
        </head>
        <body>
          <div class="pagina-guia">
            ${paginaGuia}
          </div>
          ${paginaAnexo ? `<div class="pagina-anexo">${paginaAnexo}</div>` : ""}
          <script>
            window.onload = function() {
              setTimeout(function() { window.print() }, 800)
            }
          <\/script>
        </body>
      </html>
    `

    printWindow.document.write(htmlContent)
    printWindow.document.close()
  }

  const handlePrintGuia = () => {
    generatePrintHTML()
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 print-container">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
      >
        <div className="p-6 border-b border-gray-200 flex items-center justify-between sticky top-0 bg-white no-print">
          <h3 className="text-xl font-bold text-gray-800">Visualizar Guia de Sepultamento</h3>
          <div className="flex items-center gap-2">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handlePrintGuia}
              className="px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center gap-2"
              title="Imprimir"
            >
              <Printer className="w-5 h-5" />
              <span className="text-sm font-medium">Imprimir</span>
            </motion.button>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="p-4 print-content print-guia-content">
          {/* Cabeçalho com Logo */}
          <div className="flex items-start gap-2 mb-2 pb-2 border-b border-gray-300">
            <img
              src={logoUrl}
              alt="Logo do Município"
              className="h-12 w-auto object-contain"
            />
            <div className="flex-1">
              <h2 className="text-[15px] font-bold text-gray-800 mb-0 leading-tight">
                {dadosPrefeitura.nomePrefeitura}
              </h2>
              <p className="text-[10px] text-gray-600 leading-tight">{dadosPrefeitura.secretaria}</p>
              <p className="text-[10px] text-gray-600 leading-tight">{dadosPrefeitura.departamento}</p>
              <p className="text-[10px] text-gray-600 leading-tight">
                {dadosPrefeitura.endereco} | CEP: {dadosPrefeitura.cep}
              </p>
              <p className="text-[10px] text-gray-600 leading-tight">
                CNPJ: {dadosPrefeitura.cnpj} | Tel: {dadosPrefeitura.telefone}
              </p>
            </div>
          </div>

          <h3 className="text-[14px] font-bold text-center text-gray-800 my-1.5 uppercase">
            GUIA DE SEPULTAMENTO Nº {guia.numero}
          </h3>

          {/* Informações do Falecido */}
          <div className="mb-2">
            <h4 className="text-[12px] font-semibold text-gray-700 mb-1 pb-0.5 border-b border-gray-300">
              Informações do Falecido
            </h4>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1">
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Nome Completo:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.nomeFalecido}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Data de Nascimento:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">
                  {guia.dataNascimento ? new Date(guia.dataNascimento).toLocaleDateString("pt-BR") : "Não informada"}
                </p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Idade:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.idade} anos</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Nome da Mãe:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.nomeMae}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Nome do Pai:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.nomePai}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Naturalidade:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.naturalidade}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Cor:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.cor}</p>
              </div>
            </div>
          </div>

          {/* Informações do Óbito */}
          <div className="mb-2">
            <h4 className="text-[12px] font-semibold text-gray-700 mb-1 pb-0.5 border-b border-gray-300">
              Informações do Óbito
            </h4>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1">
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Causa da Morte:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.causaMorte}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Local do Óbito:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.localObito}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Data do Óbito:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">
                  {new Date(guia.dataObito).toLocaleDateString("pt-BR")}
                </p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Hora do Óbito:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.horaObito}</p>
              </div>
            </div>
          </div>

          {/* Informações do Sepultamento */}
          <div className="mb-2">
            <h4 className="text-[12px] font-semibold text-gray-700 mb-1 pb-0.5 border-b border-gray-300">
              Informações do Sepultamento
            </h4>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1">
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Óbito Nº:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.obitoNumero}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Fls:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.fls}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Livro Nº:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.livroNumero}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Cartório:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.cartorio}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Data do Sepultamento:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">
                  {new Date(guia.dataSepultamento).toLocaleDateString("pt-BR")}
                </p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Cemitério:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.cemiterio}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Valor Pago:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">R$ {guia.valorPago}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Conforme Talão Nº:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.talaoNumero}</p>
              </div>
            </div>
          </div>

          {/* Informações do Solicitante */}
          <div className="mb-3">
            <h4 className="text-[12px] font-semibold text-gray-700 mb-1 pb-0.5 border-b border-gray-300">
              Informações do Solicitante
            </h4>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1">
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">Nome do Solicitante:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.nomeSolicitante}</p>
              </div>
              <div>
                <p className="text-[10px] text-gray-600 leading-tight">CPF:</p>
                <p className="text-[11px] font-medium text-gray-800 leading-tight">{guia.cpfSolicitante}</p>
              </div>
            </div>
          </div>

          {/* Assinaturas */}
          <div className="grid grid-cols-2 gap-5 mt-5">
            <div className="text-center">
              <div className="border-t border-gray-400 pt-1">
                <p className="text-[11px] font-medium text-gray-700 leading-tight">Assinatura do Responsável</p>
                <p className="text-[9px] text-gray-500 leading-tight">Secretaria Municipal</p>
              </div>
            </div>
            <div className="text-center">
              <div className="border-t border-gray-400 pt-1">
                <p className="text-[11px] font-medium text-gray-700 leading-tight">Assinatura do Solicitante</p>
                <p className="text-[9px] text-gray-500 leading-tight">{guia.nomeSolicitante}</p>
              </div>
            </div>
          </div>

          {/* Rodapé */}
          <div className="mt-3 text-center text-[9px] text-gray-500">
            <p>Documento emitido em {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR")}</p>
          </div>

          {/* QR Code */}
          {qrCodeUrl && (
            <div className="mt-2 pt-2 border-t border-gray-300 text-center">
              <p className="text-[9px] text-gray-500 mb-1">Escaneie para baixar o PDF</p>
              <img
                src={qrCodeUrl}
                alt="QR Code da Guia"
                className="w-16 h-16 mx-auto"
              />
            </div>
          )}

          {/* Certidão de Óbito Anexada — visualização no modal */}
          {guia.certidaoBase64 && (
            <div className="mt-4 pt-3 border-t-2 border-gray-300">
              <h4 className="text-sm font-semibold text-gray-700 mb-3 text-center">Certidão de Óbito Anexada</h4>
              <div className="flex justify-center">
                {guia.certidaoBase64.includes("application/pdf") ? (
                  <embed
                    src={guia.certidaoBase64}
                    type="application/pdf"
                    className="w-full h-[800px] border border-gray-300 rounded shadow-lg"
                  />
                ) : (
                  <img
                    src={guia.certidaoBase64}
                    alt="Certidão de Óbito"
                    className="max-w-full h-auto border border-gray-300 rounded shadow-lg"
                    style={{ maxHeight: "800px", objectFit: "contain" }}
                  />
                )}
              </div>
            </div>
          )}

        </div>
      </motion.div>
    </div>
  )
}
